import Search from "Components/Form/Inputs/Search";
import Loading from "Components/Loading";
import Pagination2 from "Components/Pagination2";
import { useProducts } from "Hooks/Products/useProducts";
import React, { useCallback, useState } from "react";
import { IAd } from "Services/Ad/ad";
import ProductItem from "./ProductItem";
import * as Styled from "./styles";

const AdminProduts: React.FC = () => {
  const [value, setValue] = useState("");
  const [search, setSearch] = useState("");

  const [page, setPage] = useState(1);

  const { data, isLoading } = useProducts({
    page: page,
    perPage: 5,
    search: search,
    published: true,
  });

  const handleChangePage = (page: number) => {
    setPage(page);
  };

  const fetchList = useCallback(() => {
    setSearch(value);
  }, [value]);

  return (
    <Styled.Container>
      <Styled.Content>
        <Styled.Title>Produtos</Styled.Title>
        <div style={{ width: 200, fontSize: "10em" }}>
          <Search
            setValue={setValue}
            placeholder="Pesquisar..."
            shadow={false}
            submit={() => fetchList()}
            newSearch={true}
          />
        </div>

        {isLoading ? (
          <Loading />
        ) : (
          <Styled.List>
            {data?.data.map((product: IAd) => (
              <ProductItem key={product.id} data={product} />
            ))}
            {data?.data && (
              <Pagination2
                lastPage={data.lastPage}
                onPageChange={handleChangePage}
                page={page}
                perPage={5}
              />
            )}
          </Styled.List>
        )}
      </Styled.Content>
    </Styled.Container>
  );
};

export default AdminProduts;
